// Globals
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuProps } from 'antd';

// Components
import { StyledMainTitleWrapper, StyledPageTitle, StyledPageWrapper } from '../../components/Styled';
import { Menu } from '@/ui';

// Modules
import { usePermissions, Resource } from '@/modules/Permissions';

// Helpers
import { CategoriesTabs, getCategoriesTabsConfig } from '../../helpers/configs';
import { useQueryParams } from '@/hooks';

const CATEGORIES_TAB_RESOURCE: Record<string, Resource> = {
  [CategoriesTabs.CATEGORIES]: Resource.CATEGORY,
  [CategoriesTabs.FILTERS]: Resource.FILTER,
  [CategoriesTabs.POPULAR_CATEGORIES]: Resource.POPULAR_CATEGORY,
};

const CategoriesMainContainer = () => {
  const { t } = useTranslation(['categories']);
  const { canView } = usePermissions();
  const defaultTab = useQueryParams('tab');
  const categoriesTabsConfig = useMemo(
    () => getCategoriesTabsConfig(t).filter((tab) => canView(CATEGORIES_TAB_RESOURCE[tab.key])),
    [canView],
  );
  const [selectedKey, setSelectedKey] = useState(defaultTab ?? '');
  const selectedCategoriesTab =
    categoriesTabsConfig.find((item) => item.key === selectedKey) ?? categoriesTabsConfig[0];

  const onClick: MenuProps['onClick'] = (e) => {
    setSelectedKey(e.key as CategoriesTabs);
  };

  return (
    <StyledPageWrapper>
      <StyledMainTitleWrapper>
        <StyledPageTitle>{t('categories_main_title')}</StyledPageTitle>
        <Menu
          mode="horizontal"
          items={categoriesTabsConfig}
          defaultSelectedKeys={selectedCategoriesTab ? [selectedCategoriesTab.key] : []}
          onClick={onClick}
        />
      </StyledMainTitleWrapper>

      {selectedCategoriesTab?.content}
    </StyledPageWrapper>
  );
};

export default CategoriesMainContainer;
